<template>
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="m6.8164 5.8154v0.54678h11.387v-0.54678h-11.387zm0 2.1715v0.54678h11.387v-0.54678h-11.387zm0 2.1715v0.5468h11.387v-0.5468h-11.387zm0 2.1871v0.5468h11.387v-0.5468h-11.387zm0 2.1715v0.5468h11.387v-0.5468h-11.387zm0 2.1871v0.5468h11.387v-0.5468h-11.387zm0 0.5312h11.387v-0.5468h-11.387v0.5468zm0-2.1715h11.387v-0.5468h-11.387v0.5468zm0-2.1715h11.387v-0.5468h-11.387v0.5468zm0-2.1871h11.387v-0.5468h-11.387v0.5468zm0-2.1715h11.387v-0.54678h-11.387v0.54678zm0-2.7183v0.54678h11.387v-0.54678h-11.387zm12.715-2.9995h-1.1719v0.81236h1.1719c0.4687 0 0.8398 0.31244 0.8398 0.68738v13.888c0 0.3749-0.3711 0.6873-0.8398 0.6873h-14.063c-0.46875 0-0.83984-0.3124-0.83984-0.6873v-13.888c0-0.37494 0.37109-0.68738 0.83984-0.68738h0.87891v-0.81236h-0.87891c-1.0156 0-1.8359 0.67176-1.8359 1.4997v13.888c0 0.8279 0.82031 1.4997 1.8359 1.4997h14.063c1.0156 0 1.8359-0.6718 1.8359-1.4997v-13.888c0-0.82798-0.8203-1.4997-1.8359-1.4997zm-12.715 14.419h11.387v-0.5468h-11.387v0.5468zm11.367-2.7183h-11.367v0.5468h11.387v-0.5468h-0.0195zm0-2.1715h-11.367v0.5468h11.387v-0.5468h-0.0195zm0-2.1871h-11.367v0.5468h11.387v-0.5468h-0.0195zm0-2.1715h-11.367v0.54678h11.387v-0.54678h-0.0195zm0-2.1715h-11.367v0.54678h11.387v-0.54678h-0.0195zm-3.8477-3.6869v-0.62489c0-0.40618-0.2148-0.78112-0.5468-1.0623-0.3321-0.26558-0.8008-0.43742-1.2891-0.43742-1.0156 0-1.8359 0.67176-1.8359 1.4997v0.64051h-3.3204v2.3121h10v-2.3277h-3.0079zm-1.8359-1.2185c0.3711 0 0.6641 0.24996 0.6641 0.54678s-0.293 0.54678-0.6641 0.54678-0.6641-0.24996-0.6641-0.54678 0.293-0.54678 0.6641-0.54678z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "PrescricaoProcedimentoMinIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
